import React from 'react';
import { Dialog, DialogTitle, Typography, LinearProgress, makeStyles } from '@material-ui/core';
import { MODAL_BACKGROUND_COLOR, SECONDARY_COLOR } from '../../theme';

export const ModalProgresso = props => {
    const classes = useStyles(props);
    const {
        modalAberto,
        fecharModal,
        titulo
    } = props;

    return (
        <Dialog
            fullWidth
            classes={{ paperWidthXs: classes.paperWidthXs }}
            maxWidth={'xs'}
            open={modalAberto}
            onClose={fecharModal}
        >
            <div className={classes.root}>
                <DialogTitle disableTypography id='modal-impressao-titulo'>
                    <Typography className={classes.tituloModal} variant='h4'>
                        {titulo}
                    </Typography>
                </DialogTitle>
                <LinearProgress className={classes.barraProgresso} classes={{ corPrimariaProgresso: classes.corPrimariaProgresso }} />
            </div>
        </Dialog>
    );
}


const useStyles = makeStyles({
    root: {
        backgroundColor: MODAL_BACKGROUND_COLOR,
        paddingBottom: '35px',
        paddingTop: '15px'
    },
    corPrimariaProgresso: {
        backgroundColor: SECONDARY_COLOR
    },
    tituloModal: {
        fontWeight: 'bold',
        textAlign: 'center',
        paddingBottom: '15px'
    },
    barraProgresso: {
        marginLeft: '24px',
        marginRight: '24px'
    },
    paperWidthXs: {
        width: '350px'
    },
});

export default ModalProgresso;